export const quotePrivateURL : string = '/quotedetails/private';
export const quoteCommercialURL : string = '/quotedetails/commercial';
export const quoteSpecialURL : string = '/quotedetails/specialtypes';
export const quoteMotorcycleURL : string = '/quotedetails/motorcycles';

export const kycPrivateURL : string = '/kyc/private';
export const kycCommercialURL : string = '/kyc/commercial';
export const kycSpecialURL : string = '/kyc/specialtypes';
export const kycMotorcycleURL : string = '/kyc/motorcycles';


// export const claimDetailsURL : string = '/claim';
export const claimExtraDetailsURL : string = '/claim/data'
export const claimFormURL : string = '/claim/continued';

// Version 2 FNOL
export const claimFnolURL : string = '/claim/fnol';
export const claimDetailsURL : string = '/claim/details';

export const quoteUG_URL : string = '/ug/quotedetails';
export const claimUG_URL : string = '/ug/claimdetails';

export const thirdPartyBuyKYC_URL : string = '/tz/third-party/kyc';
export const benefitsTZ_URL : string = '/tz/benefits';
export const kycTZ_URL : string = '/tz/kyc';
export const claimTZ_URL : string = '/tz/claim';

export const vehicleMakeURL : string = '/vehiclemake';
export const vehicleModelURL : string = '/vehiclemodels';
export const banksURL : string = '/banks';
export const bankBranchesURL : string = '/bank-branches';
export const regionsURL : string = '/regions';
export const garagesURL : string = '/garages';
export const glaziersURL : string = '/glaziers';

export const policyDetailsURL : string = '/policy-details';

export const tokenPlaceholderValue : string = 'replaceme'

// Domestic Package (DP) KE
export const dpQuoteURL: string = '/quote';
export const dpPersonalDetailsURL: string = '/personal-details';
export const dpBuildingDetailsURL: string = '/building-details';
export const dpImeiDetailsURL: string = '/imei-details';
export const dpClaimURL: string = '/claim';